import { defineKey as T } from 'ha/i18n';

export const ERROR_MESSAGES = {
  INVALID_PHONE: T('Incorrect phone number'),
  SERVER_ERROR: T(
    'There was a problem processing your request. Please contact our support if the error persists.',
  ),
};
